<template>
  <!-- `table-wrapper` gives the table the theme's dark rows, as elsewhere. -->
  <div class="table-wrapper">
    <ImportErrorAlert
      :title="$tc(`${I18N}.title`, labels.length)"
      :lines="lines"
      class="unresolved-labels__alert"
    >
      <CopyToClipboardButton
        slot="actions"
        :text="tsv"
        :label="$t(`${I18N}.copy`)"
      />
    </ImportErrorAlert>

    <el-table
      :data="rows"
      :max-height="300"
      :default-sort="{ prop: 'sourceRow', order: 'ascending' }"
    >
      <el-table-column
        prop="sourceRow"
        :label="$t(`${I18N}.columns.sourceRow`)"
        sortable
        width="100"
      />
      <el-table-column :label="$t(`${I18N}.columns.label`)">
        <FileLabel
          slot-scope="{ row }"
          :label="row.label"
        />
      </el-table-column>
      <el-table-column
        column-key="issue"
        :label="$t(`${I18N}.columns.issue`)"
        :filters="issueFilters"
        :filter-method="hasIssue"
      >
        <template slot-scope="{ row }">
          <i
            :class="row.issue.icon"
            aria-hidden="true"
          />
          {{ $t(row.issue.titleKey) }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t(`${I18N}.columns.fix`)"
        :formatter="formatFix"
      />
    </el-table>
  </div>
</template>

<script>
  import CopyToClipboardButton from '@/components/CopyToClipboardButton.vue';
  import ImportErrorAlert from './ImportErrorAlert.vue';
  import FileLabel from './FileLabel.vue';
  import {
    countLabelIssues,
    issueLines,
    labelIssue,
    labelIssuesToTsv,
    sortBySourceRow,
  } from './labelIssues';

  // Error summary of the labels that block the import (REQ-06, C21): every
  // cause with its fix, then every label, none left out.
  export default {
    name: 'UnresolvedLabelsSummary',
    components: { CopyToClipboardButton, ImportErrorAlert, FileLabel },
    props: {
      labels: { type: Array, required: true },
    },
    data() {
      return {
        I18N: 'analysesData.importValues.unresolvedLabels',
      };
    },
    computed: {
      rows() {
        return sortBySourceRow(this.labels).map((label) => ({
          ...label,
          issue: labelIssue(label),
        }));
      },
      issueCounts() {
        return countLabelIssues(this.labels);
      },
      lines() {
        return issueLines(this.issueCounts, this.translate);
      },
      issueFilters() {
        return this.issueCounts.map(({ key, titleKey }) => ({
          text: this.$t(titleKey),
          value: key,
        }));
      },
      tsv() {
        return labelIssuesToTsv(this.labels, this.translate);
      },
    },
    methods: {
      translate(key, values) {
        return this.$t(key, values);
      },
      hasIssue(key, row) {
        return row.issue.key === key;
      },
      formatFix({ issue }) {
        return this.$t(issue.fixKey);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .unresolved-labels__alert {
    margin-bottom: 1rem;
  }
</style>
